import { Translate } from '../config/Translate';

// html2pdf 는 렌더 중 화면 전체를 덮는 투명 덮개(.html2pdf__overlay)를 붙이고 성공 경로에서만 뗀다.
// 실패하면 덮개가 남아 화면이 눌리지 않으므로 여기서 치우고 사용자에게 알린다.
export const runPdfExport = (job, handler) =>
    Promise.resolve(job).catch((err) => {
        document.querySelectorAll('.html2pdf__overlay').forEach((el) => el.remove());
        console.warn('[pdf-export] PDF 생성 실패', {
            handler,
            reason: err?.message ?? String(err),
        });
        try {
            // 순환 참조 회피를 위해 지연 require (axiosSetup.js 와 같은 패턴)
            const { store } = require('../store');
            const { AlertAction } = require('../actions/AlertAction');
            store.dispatch(AlertAction.ErrorMsg(Translate('common.message.error.processingFailed')));
        } catch (e) {
            console.warn('[pdf-export:error] 실패 안내 표시 실패', e?.message);
        }
        return undefined;
    });
